const o=t=>"sletatUIComponents2_"+t.join("_");export{o as getStaticClassNames};
